// module
import React from 'react';
import { Link } from 'react-router-dom';

import img01 from '../img/1page.png'

function Home(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">About GAAP</h2>
            <div className="content_text">
                GAAP is a genome analysis pipeline for semi-automated, iterative, 
                and high-throughput analysis of whole-genome data. 
                This pipeline is designedto perform read correction, 
                de novo genome (transcriptome) assembly, gene prediction,
                and functional annotation using a range of proven tools and databases. 
                The pipeline enables a researcher without expertise in 
                IT to perform a complete genome analysis.
            </div>
            <div className="content_box">
                <div className="content_box_title">
                    The overall workflow of the system
                </div>
                <div className="content_box_body">
                    <img className="content_box_img" src={img01} alt='error'/>
                </div>
            </div>
            <Link className="content_button_single" to="/manual"><button className="content_button">Next</button></Link>
            <br/><br/><br/>
        </div>
    );
}

export default Home;